/**
 * Configuration utilities for the Copilot feature
 */

// Get the API URL from environment variables or use a default
export const getApiUrl = (): string => {
  return import.meta.env.VITE_COPILOT_API_URL || 'http://localhost:2024';
};

// Get the assistant ID from environment variables or use a default
export const getAssistantId = (): string => {
  return import.meta.env.VITE_COPILOT_ASSISTANT_ID || 'agent';
};

// Local storage keys
export const STORAGE_KEYS = {
  SIDEBAR_STATE: 'copilot-sidebar-state',
  CHAT_HISTORY: 'copilot-chat-history',
  THEME: 'copilot-theme',
  THREAD_ID: 'copilot-thread-id',
};

// Default values
export const DEFAULTS = {
  SIDEBAR_WIDTH: 500,
  BUTTON_POSITION: 'bottom-right' as const,
  THEME: 'system' as const,
};
